import { render, staticRenderFns } from "./WordDetailModal.vue?vue&type=template&id=6fde1ce8&scoped=true"
import script from "./WordDetailModal.vue?vue&type=script&lang=js"
export * from "./WordDetailModal.vue?vue&type=script&lang=js"
import style0 from "./WordDetailModal.vue?vue&type=style&index=0&id=6fde1ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde1ce8",
  null
  
)

export default component.exports